import { render, staticRenderFns } from "./TagVoucherType.vue?vue&type=template&id=69df8b1c"
import script from "./TagVoucherType.vue?vue&type=script&lang=js"
export * from "./TagVoucherType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports